module.exports = __webpack_public_path__ + "media/Duhamel-Logistique-Export-1.966e1e6c.mp4";